// Static league data + shared types for the fantasy recap page. Pure data,
// split out of FantasyPageClient so that file stays composition + view.

type TeamMetric = {
  team: string
  manager: string
  rank: number
  tablePoints: number
  pointsFor: number
  pointsForRank: number
  expectedRank: number
  scheduleLuck: number
  chaos: number
  uniquePlayers: number
  transactions: number
  persona: string
  verdict: string
}

type PowerRank = {
  rank: number
  team: string
  movement: string
  title: string
  case: string
  receipt: string
}

type TeamBuild = {
  team: string
  manager: string
  draft: string[]
  now: string[]
  identity: string
  swing: string
}

export const teams: TeamMetric[] = [
  {
    team: 'fent folders',
    manager: 'Rohit',
    rank: 1,
    tablePoints: 72,
    pointsFor: 1504,
    pointsForRank: 2,
    expectedRank: 2,
    scheduleLuck: 7.23,
    chaos: 77,
    uniquePlayers: 48,
    transactions: 44,
    persona: 'The waiver hawk',
    verdict:
      'This is what happens when a good team also keeps showing up on waivers. Rohit has the points, the table lead, and very few places for the staff to poke holes.',
  },
  {
    team: 'wadeland',
    manager: 'Arush',
    rank: 2,
    tablePoints: 64,
    pointsFor: 1387,
    pointsForRank: 5,
    expectedRank: 4,
    scheduleLuck: 5.69,
    chaos: 16,
    uniquePlayers: 23,
    transactions: 8,
    persona: 'The quiet contender',
    verdict:
      'Wadeland has not needed theatrics. Arush kept the squad steady, got production from the right places, and stayed near the top while louder teams explained themselves.',
  },
  {
    team: 'Real Manhattan',
    manager: 'Teddy',
    rank: 3,
    tablePoints: 63,
    pointsFor: 1515,
    pointsForRank: 1,
    expectedRank: 1,
    scheduleLuck: -4.38,
    chaos: 85,
    uniquePlayers: 52,
    transactions: 48,
    persona: 'The commissioner’s complaint',
    verdict:
      'Real Manhattan leads the league in points and still sits third. Teddy can complain, and for once the numbers do not immediately roll their eyes.',
  },
  {
    team: 'Leyverpool',
    manager: 'Leyland',
    rank: 4,
    tablePoints: 61,
    pointsFor: 1329,
    pointsForRank: 7,
    expectedRank: 7,
    scheduleLuck: 8.54,
    chaos: 0,
    uniquePlayers: 15,
    transactions: 0,
    persona: 'The untouched draft room',
    verdict:
      'Zero accepted moves, fifteen total rostered players, fourth place. Leyland treated the waiver wire like a terms-of-service update and somehow survived.',
  },
  {
    team: 'Old Lady',
    manager: 'Nic',
    rank: 5,
    tablePoints: 56,
    pointsFor: 1304,
    pointsForRank: 11,
    expectedRank: 10,
    scheduleLuck: 6.31,
    chaos: 23,
    uniquePlayers: 26,
    transactions: 12,
    persona: 'The respectable spoiler',
    verdict:
      'Old Lady is not dominating the scoring charts, but Nic has turned enough ordinary weeks into useful table points to become very annoying.',
  },
  {
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    rank: 6,
    tablePoints: 54,
    pointsFor: 1414,
    pointsForRank: 3,
    expectedRank: 5,
    scheduleLuck: -2.69,
    chaos: 36,
    uniquePlayers: 32,
    transactions: 19,
    persona: 'The late-season climber',
    verdict:
      'Third in points and still sixth is a strange place to live. Gibbs-White helped turn Chunky jeet FC from middle-class noise into a real closing-stretch problem.',
  },
  {
    team: 'A',
    manager: 'Ahmed',
    rank: 8,
    tablePoints: 50,
    pointsFor: 1238,
    pointsForRank: 12,
    expectedRank: 12,
    scheduleLuck: 4.62,
    chaos: 16,
    uniquePlayers: 23,
    transactions: 8,
    persona: 'The quiet counterpuncher',
    verdict:
      'A does not give us much copy, which is inconsiderate. But Rice, Virgil, Salah, and a few timely defenders have kept Ahmed close enough to bother people.',
  },
  {
    team: 'Big Micha',
    manager: 'Hugh',
    rank: 9,
    tablePoints: 49,
    pointsFor: 1352,
    pointsForRank: 6,
    expectedRank: 8,
    scheduleLuck: -3.15,
    chaos: 55,
    uniquePlayers: 41,
    transactions: 29,
    persona: 'The record-week problem',
    verdict:
      'The 89-point week is real and deserves respect. The problem is the rest of the season keeps walking into the room right after it.',
  },
  {
    team: 'Son Doku',
    manager: 'Jonathan',
    rank: 9,
    tablePoints: 49,
    pointsFor: 1412,
    pointsForRank: 4,
    expectedRank: 3,
    scheduleLuck: -12.54,
    chaos: 30,
    uniquePlayers: 30,
    transactions: 15,
    persona: 'The schedule victim',
    verdict:
      'Fourth in points, third by all-play expectation, ninth in the table. Jonathan did enough to be higher. The schedule simply disagreed.',
  },
  {
    team: 'MBOOMO',
    manager: 'Raed',
    rank: 11,
    tablePoints: 48,
    pointsFor: 1327,
    pointsForRank: 9,
    expectedRank: 9,
    scheduleLuck: -2.62,
    chaos: 62,
    uniquePlayers: 44,
    transactions: 33,
    persona: 'The big-name roster',
    verdict:
      'MBOOMO has had the kind of names that look good in a group chat screenshot. The table has been less impressed, but the first trade is aging in Ra’ed’s favor.',
  },
  {
    team: 'Yanited',
    manager: 'Akash',
    rank: 12,
    tablePoints: 47,
    pointsFor: 1328,
    pointsForRank: 8,
    expectedRank: 11,
    scheduleLuck: -2.46,
    chaos: 51,
    uniquePlayers: 38,
    transactions: 28,
    persona: 'The aura team',
    verdict:
      'Yanited is still hard to rank because the numbers say middle class and the group chat says main character. Akash has made both feel true.',
  },
  {
    team: 'Hookah Doncic',
    manager: 'Arne',
    rank: 13,
    tablePoints: 37,
    pointsFor: 1139,
    pointsForRank: 13,
    expectedRank: 13,
    scheduleLuck: -0.62,
    chaos: 51,
    uniquePlayers: 40,
    transactions: 26,
    persona: 'The rebuild attempt',
    verdict:
      'Hookah made moves and made the first trade. The trouble is that too many good Sundays still happened on someone else’s roster.',
  },
  {
    team: 'Shyam’s Your Daddy',
    manager: 'Shyam',
    rank: 14,
    tablePoints: 28,
    pointsFor: 1090,
    pointsForRank: 14,
    expectedRank: 14,
    scheduleLuck: -0.92,
    chaos: 4,
    uniquePlayers: 17,
    transactions: 2,
    persona: 'The unattended team',
    verdict:
      'Fourteenth in points, fourteenth by expectation, two accepted transactions. Sometimes the simplest explanation is also the rudest one.',
  },
]

export const powerRankings: PowerRank[] = [
  {
    rank: 1,
    team: 'fent folders',
    movement: '-0-',
    title: 'The favorite until proven otherwise',
    case: 'Rohit has the cleanest case in the league. He scores like a contender, manages like someone who actually checks the app, and has not given the staff enough bad losses to build a real opposition file.',
    receipt: '#2 points for, #2 expected rank, 44 accepted transactions.',
  },
  {
    rank: 2,
    team: 'Real Manhattan',
    movement: '↑1',
    title: 'The points leader with a grievance',
    case: 'Real Manhattan is first in points and first by all-play, which means Teddy’s usual commissioner complaints finally have some statistical backing. The problem is that the table only pays out wins.',
    receipt:
      '1515 points for, -4.38 schedule luck, 52 unique rostered players.',
  },
  {
    rank: 3,
    team: 'Son Doku',
    movement: '↑6',
    title: 'The season’s unluckiest good team',
    case: 'Jonathan has a much better team than the table says. GW31 tells the story cleanly: 50 points, second-best score of the week, and still a loss because Real Manhattan happened to have 52.',
    receipt: '#4 points for, #3 expected rank, -12.54 schedule luck.',
  },
  {
    rank: 4,
    team: 'wadeland',
    movement: '↓2',
    title: 'The low-drama contender',
    case: 'Wadeland has spent most of the season refusing to become content. Arush has not needed many moves; the core has simply been good enough for long enough.',
    receipt: '64 table points with only 8 accepted transactions.',
  },
  {
    rank: 5,
    team: 'Chunky jeet FC',
    movement: '↑1',
    title: 'The roster that got interesting late',
    case: 'If Gibbs-White is the headline, the larger point is that Chunky jeet FC has quietly become one of the league’s best scoring teams. Ashaank may have found the right shape a little late, but he found it.',
    receipt: '#3 points for; Gibbs-White posted 152 points after pickup.',
  },
  {
    rank: 6,
    team: 'Leyverpool',
    movement: '↓2',
    title: 'The no-move experiment',
    case: 'Leyland did nothing. This is not exaggeration. The transaction ledger is empty, the original roster is still recognizable, and somehow Leyverpool remains near the Champions League places.',
    receipt:
      '0 accepted transactions, 15 unique rostered players, +8.54 schedule luck.',
  },
  {
    rank: 7,
    team: 'Big Micha',
    movement: '↑2',
    title: 'The 89-point question',
    case: 'Big Micha owns the best week of the season. It was huge, ridiculous, and yes, inflated by double fixtures, but the points still counted and Hugh will make sure everyone remembers that.',
    receipt: 'GW33: 89 points, the best team week of the season.',
  },
  {
    rank: 8,
    team: 'MBOOMO',
    movement: '↑3',
    title: 'The roster that looks better on paper',
    case: 'MBOOMO has names that sound like they should be higher than eleventh. Bruno Fernandes, Wirtz, Woltemade, Thiaw. The weekly output has not always matched the poster, but the Hookah trade has.',
    receipt:
      'MBOOMO trade package +33 rest-of-season points over Hookah’s package.',
  },
  {
    rank: 9,
    team: 'Yanited',
    movement: '↑3',
    title: 'The loudest middle class team',
    case: 'Akash remains difficult to evaluate. Yanited is twelfth in the table and eighth in points, but somehow every win feels like a statement and every loss feels like material.',
    receipt:
      '1328 points for, 28 accepted transactions, 38 unique rostered players.',
  },
  {
    rank: 10,
    team: 'Old Lady',
    movement: '↓5',
    title: 'The schedule-friendly spoiler',
    case: 'Old Lady has not always been pretty, but Nic has stolen enough important weeks to stay relevant. Reece James accounting for 60 percent of a team score in GW8 remains one of the stranger box scores of the year.',
    receipt: '+6.31 schedule luck; James had 18 of 30 points in GW8.',
  },
  {
    rank: 11,
    team: 'A',
    movement: '↓3',
    title: 'The quiet wildcard',
    case: 'Ahmed remains difficult to write about because he gives us very little and occasionally wins anyway. Rice and Virgil have been enough to keep A from becoming a full afterthought.',
    receipt: '50 table points despite ranking 12th in points for.',
  },
  {
    rank: 12,
    team: 'Hookah Doncic',
    movement: '↑1',
    title: 'The trade did not fix enough',
    case: 'Hookah made the first trade and did become more interesting. Unfortunately, interesting and good are different categories, and the table has been very clear about that.',
    receipt: '26 accepted transactions, 40 unique players, 37 table points.',
  },
  {
    rank: 13,
    team: 'Shyam’s Your Daddy',
    movement: '↓1',
    title: 'The team we are still waiting on',
    case: 'Shyam has not made many moves, has not scored many points, and has still found a few annoying wins. The staff remains open to changing this ranking if the owner starts acting like there is a ranking to change.',
    receipt: '2 accepted transactions, 1090 points for, 28 table points.',
  },
]

export const builds: TeamBuild[] = [
  {
    team: 'Hookah Doncic',
    manager: 'Arne',
    draft: ['R1 Wirtz', 'R2 Odegaard', 'R3 Neto', 'R4 Martinelli', 'R5 Raul'],
    now: ['Guehi', 'Gakpo', 'Ballard', 'Neto', 'Leno'],
    identity: 'From preseason flair to midseason trade-court TV.',
    swing:
      'The first-round pick literally became the other side of the MBOOMO trade.',
  },
  {
    team: 'MBOOMO',
    manager: 'Raed',
    draft: [
      'R1 B.Fernandes',
      'R2 Eze',
      'R3 Gakpo',
      'R4 Frimpong',
      'R5 Ait-Nouri',
    ],
    now: ['B.Fernandes', 'Chalobah', 'Wirtz', 'Verbruggen', 'Thiaw'],
    identity:
      'A luxury roster showroom with a surprisingly active loading dock.',
    swing:
      'Wirtz came in by trade; Gakpo left; Bruno stayed as the franchise signage.',
  },
  {
    team: 'Real Manhattan',
    manager: 'Teddy',
    draft: [
      'R1 Haaland',
      'R2 Gibbs-White',
      'R3 Gordon',
      'R4 Barry',
      'R5 Mac Allister',
    ],
    now: ['Haaland', 'Wilson', 'Kelleher', 'Gravenberch', 'E.Le Fee'],
    identity:
      'High-volume trader, high-volume scorer, high-volume grievance department.',
    swing:
      'Dropping Gibbs-White created the single loudest regret file in the database.',
  },
  {
    team: 'Son Doku',
    manager: 'Jonathan',
    draft: [
      'R1 Marmoush',
      'R2 Solanke',
      'R3 Cherki',
      'R4 Gabriel',
      'R5 Szoboszlai',
    ],
    now: ['Gabriel', 'Casemiro', 'Szoboszlai', 'Pickford', 'Cherki'],
    identity: 'Good roster, cursed calendar, group-chat plaintiff.',
    swing: 'The build became more stable than the table position suggests.',
  },
  {
    team: 'Leyverpool',
    manager: 'Leyland',
    draft: ['R1 Watkins', 'R2 Sesko', 'R3 Semenyo', 'R4 Kudus', 'R5 Kerkez'],
    now: ['Semenyo', 'Thiago', 'J.Timber', 'Mosquera', 'Watkins'],
    identity: 'The draft-day time capsule that kept passing health checks.',
    swing: 'Zero accepted moves. Semenyo and Thiago simply became the plot.',
  },
  {
    team: 'fent folders',
    manager: 'Rohit',
    draft: [
      'R1 Gyokeres',
      'R2 Mateta',
      'R3 Strand Larsen',
      'R4 Sarr',
      'R5 Cucurella',
    ],
    now: ['Dewsbury-Hall', 'Scott', 'Konate', 'Gyokeres', 'Schade'],
    identity: 'Aggressive waiver desk with championship-grade risk controls.',
    swing:
      'The roster changed constantly without losing the league’s main thread.',
  },
  {
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    draft: [
      'R1 Palmer',
      'R2 Wissa',
      'R3 Evanilson',
      'R4 Schade',
      'R5 Pedro Porro',
    ],
    now: ['Gibbs-White', 'Senesi', 'Anderson', 'Garner', 'Andersen'],
    identity:
      'Nottingham energy, waiver receipts, credible late-season danger.',
    swing: 'Gibbs-White turned a pickup into a franchise-history exhibit.',
  },
  {
    team: 'Big Micha',
    manager: 'Hugh',
    draft: ['R1 Isak', 'R2 Wood', 'R3 Rogers', 'R4 Munoz', 'R5 Gvardiol'],
    now: ['Rogers', 'Henderson', 'Munoz', 'Richards', 'O.Dango'],
    identity: 'One record-breaking volcano surrounded by uncertain weather.',
    swing:
      'Isak became the first-round bust case; GW33 became the defense attorney.',
  },
  {
    team: 'Old Lady',
    manager: 'Nic',
    draft: [
      'R1 Ekitike',
      'R2 Cunha',
      'R3 Kluivert',
      'R4 Johnson',
      'R5 Maddison',
    ],
    now: ['Raya', 'Truffert', 'Cunha', 'Tavernier', 'Aaronson'],
    identity: 'Veteran stability with just enough chaos to steal Sundays.',
    swing:
      'Donnarumma was the waiver snipe, but Raya and Truffert carried the portrait wall.',
  },
  {
    team: 'Yanited',
    manager: 'Akash',
    draft: ['R1 Mbeumo', 'R2 Madueke', 'R3 Elanga', 'R4 Welbeck', 'R5 Savinho'],
    now: ["O'Reilly", 'Tarkowski', 'Matheus N.', 'Van Hecke', 'Mbeumo'],
    identity:
      'Aura, Manchester-adjacent defenders, and several emotional filings.',
    swing: 'The names got less glamorous and somehow more annoying to play.',
  },
  {
    team: 'wadeland',
    manager: 'Arush',
    draft: ['R1 Bowen', 'R2 Joao Pedro', 'R3 Amad', 'R4 Saliba', 'R5 Nkunku'],
    now: ['Joao Pedro', 'Bowen', 'Lacroix', 'Bruno G.', 'Roefs'],
    identity: 'Low churn, high floor, quietly rude results.',
    swing:
      'The two-forward base survived the whole season better than most group chats.',
  },
  {
    team: 'A',
    manager: 'Ahmed',
    draft: ['R1 M.Salah', 'R2 Virgil', 'R3 Mitoma', 'R4 Rice', 'R5 Rodrigo'],
    now: ['Rice', 'Virgil', 'Mukiele', 'Anthony', 'M.Salah'],
    identity:
      'Occasional silence interrupted by a top-six player ruining someone’s day.',
    swing:
      'Rice became the stabilizer while Salah became the late-season question mark.',
  },
  {
    team: 'Shyam’s Your Daddy',
    manager: 'Shyam',
    draft: ['R1 Saka', 'R2 Foden', 'R3 Havertz', 'R4 Enzo', 'R5 Delap'],
    now: ['Saka', 'Enzo', 'Mitchell', 'Cash', 'Foden'],
    identity: 'Good bones, absent contractor.',
    swing: 'The roster did not change enough to hide from the table.',
  },
]

export const charts = [
  {
    slug: 'points_vs_table.svg',
    title: 'The Table Lied',
    eyebrow: 'points versus standings',
    copy: 'Real Manhattan and Son Doku are the exhibit labels for the gap between performance and reward.',
    note: 'The plot has three neighborhoods. Rohit and Teddy are playing a different scoring sport at the top. Most of the league is living in the same crowded apartment in the middle. Hookah and Shyam are down in the basement with separate utility meters.',
  },
  {
    slug: 'schedule_luck.svg',
    title: 'Schedule Luck Courtroom',
    eyebrow: 'all-play expected points',
    copy: 'Every matchup is replayed against everyone else. This is where the excuses either die or become evidence.',
    note: 'This is the Son Doku chart. Jonathan is not imagining things: the all-play table likes him much more than the actual table does. Leyverpool is the opposite, which is probably exactly what Leyland would prefer nobody look at for too long.',
  },
  {
    slug: 'bad_beat_weeks.svg',
    title: 'The Wrong Opponent Machine',
    eyebrow: 'bad beats',
    copy: 'Weeks where a team did enough to beat nearly everyone and still walked away with nothing.',
    note: 'The brutal version of a loss: you scored enough to beat almost everyone, then drew the one team that scored more. GW31 Son Doku is the exhibit.',
  },
  {
    slug: 'greatest_individual_weeks.webp',
    title: 'Individual Week Hall of Fame',
    eyebrow: 'player apex',
    copy: 'J.Timber’s 24-point GW2 still sits on the throne, with Van de Ven and Mavropanos filing paperwork below.',
    note: 'The leaderboard is defender-heavy in the funniest way. Timber, Van de Ven, and Mavropanos are not the names people drafted to become weekly nuclear events, which is exactly why they made the list.',
  },
  {
    slug: 'one_man_shows.webp',
    title: 'One-Man Shows',
    eyebrow: 'hero ball',
    copy: 'Weeks where one player did so much of the work that the rest of the lineup should have sent a thank-you text.',
    note: 'This chart is less about greatness and more about dependency. If one player is half the team score, the manager should be grateful and also a little worried.',
  },
  {
    slug: 'top_pickups.webp',
    title: 'Waiver Wire Crime Scene',
    eyebrow: 'post-pickup production',
    copy: 'The players who were sitting there, available, before someone changed the tone of the season.',
    note: 'Gibbs-White at 152 post-pickup points stops being a waiver claim and starts being a draft-night brag people will mis-remember as inevitable. Senesi and Truffert make this an uncomfortable chart for anyone who skipped early waivers.',
  },
  {
    slug: 'player_fpl_bpm_scatter.webp',
    title: 'FPL-BPM Star Map',
    eyebrow: 'advanced player value',
    copy: 'The field is dots. The stars and weirdos get faces. This is our closest thing to VORP until someone gives us tracking data.',
    note: 'The fun of this chart is the separation. The best fantasy players are pulling away from the field in both raw production and our rough value metric. Use it the next time the group chat tries to claim someone got robbed.',
  },
  {
    slug: 'roster_chaos.svg',
    title: 'Roster Chaos Index',
    eyebrow: 'movement profile',
    copy: 'Some teams drafted a roster. Others conducted a season-long open casting call.',
    note: 'Real Manhattan and fent folders churned constantly. Leyverpool did not move at all. Both approaches are currently above Hookah, which is inconvenient for anyone trying to make a clean management philosophy argument.',
  },
]

export const badBeats = [
  ['GW31', 'Son Doku', '50-52 vs Real Manhattan', 'would beat 12 of 13'],
  ['GW5', 'Leyverpool', '47-48 vs A', 'second-highest lost to first'],
  [
    'GW33',
    'Son Doku',
    '61-70 vs Yanited',
    'high-score loss in a carnival week',
  ],
  [
    'GW21',
    'Real Manhattan',
    '55-58 vs Leyverpool',
    'third-best score, zero table points',
  ],
]

export const awards = [
  {
    title: 'Unluckiest Team',
    winner: 'Son Doku',
    detail:
      'Jonathan finished fourth in points and third by all-play expectation while sitting ninth in the real table. The GW31 50-52 loss to Real Manhattan is the season in one sad screenshot.',
    stat: '-12.54 schedule luck',
  },
  {
    title: 'Best Pickup',
    winner: 'Gibbs-White to Chunky jeet FC',
    player: 'Gibbs-White',
    detail:
      'Picked up in GW9, then produced 152 post-pickup points. Real Manhattan dropping him earlier is the league’s Zapruder film.',
    stat: '+126 net after pickup',
  },
  {
    title: 'Greatest Individual Week',
    winner: 'J.Timber, Leyverpool',
    player: 'J.Timber',
    detail:
      'A 24-point GW2 defender eruption. Every fantasy league needs one defender week that makes the scoring rules look fake.',
    stat: '24 points',
  },
  {
    title: 'Greatest Team Week',
    winner: 'Big Micha',
    detail:
      'Hugh’s GW33 89-point record is impressive, historic, and suspiciously double-fixture flavored. A banner may be raised, but possibly in pencil.',
    stat: '89 points',
  },
  {
    title: 'Best Waiver Snipe',
    winner: 'Old Lady for Donnarumma',
    player: 'Donnarumma',
    detail:
      'Nic beat Real Manhattan, fent folders, and Big Micha to Donnarumma in GW4. Three managers walked up to the waiver desk and Nic walked out with the goalkeeper.',
    stat: '120 post-claim points',
  },
  {
    title: 'The Hot Potato',
    winner: 'Woltemade, Nmecha, Osula',
    player: 'Woltemade',
    detail:
      'Each appeared on four different IPL rosters. At some point these players stopped being assets and became shared custody arrangements.',
    stat: '4 teams each',
  },
]

export const oneManShows = [
  {
    player: 'James',
    team: 'Old Lady',
    week: 'GW8',
    points: 18,
    teamPoints: 30,
    share: 60,
    result: 'Loss vs A',
    note: 'Reece James scored 18 of Old Lady’s 30. Nic still lost, which is a very efficient way to waste a hero game.',
  },
  {
    player: 'Saka',
    team: 'Shyam’s Your Daddy',
    week: 'GW26',
    points: 13,
    teamPoints: 25,
    share: 52,
    result: 'Loss vs Yanited',
    note: 'Saka was more than half the team. That is usually a compliment to Saka and a question for everyone else.',
  },
  {
    player: 'Thiago',
    team: 'Leyverpool',
    week: 'GW32',
    points: 13,
    teamPoints: 26,
    share: 50,
    result: 'Win vs Shyam',
    note: 'Leyverpool got exactly half its points from Igor Thiago and still won. The no-move season continued to make no sense.',
  },
  {
    player: 'Gyökeres',
    team: 'fent folders',
    week: 'GW35',
    points: 16,
    teamPoints: 33,
    share: 48,
    result: 'Loss vs Old Lady',
    note: 'Even the top side had a week where one forward was doing most of the lifting and the rest of the lineup looked late.',
  },
  {
    player: 'Woltemade',
    team: 'MBOOMO',
    week: 'GW17',
    points: 13,
    teamPoints: 27,
    share: 48,
    result: 'Loss vs A',
    note: 'Woltemade nearly carried MBOOMO by himself, which fits the whole MBOOMO experience: impressive names, complicated results.',
  },
  {
    player: 'João Pedro',
    team: 'wadeland',
    week: 'GW29',
    points: 19,
    teamPoints: 40,
    share: 48,
    result: 'Win vs Big Micha',
    note: 'João Pedro gave Arush almost half the points in a win, the exact kind of clean contribution Wadeland has lived on.',
  },
]

export const tradeSides = [
  {
    team: 'MBOOMO',
    manager: 'Raed',
    package: [
      { player: 'Bassey', points: 93 },
      { player: 'Wirtz', points: 123 },
      { player: 'Woltemade', points: 96 },
    ],
    total: 257,
    rostered: 238,
    color: '#4ea97e',
    note: 'Ra’ed took the younger, higher-variance side of the deal. The points since then have given MBOOMO the early receipt.',
  },
  {
    team: 'Hookah Doncic',
    manager: 'Arne',
    package: [
      { player: 'Guéhi', points: 162 },
      { player: 'Gakpo', points: 125 },
      { player: 'Muniz', points: 31 },
    ],
    total: 224,
    rostered: 224,
    color: '#d6654f',
    note: 'Hookah got the safer Premier League names and did become better. The problem is that MBOOMO’s side has still outscored it.',
  },
]

export const seasonNuggets = [
  {
    title: 'Leyverpool did not make an accepted move',
    body: 'Leyland has zero accepted transactions, 15 unique rostered players, and fourth place. That is either patience, negligence, or a man who forgot the waiver wire had buttons.',
    stat: '0 moves',
  },
  {
    title: 'Real Manhattan changed almost everything',
    body: 'Teddy has 48 accepted transactions, 52 unique rostered players, and the most points in the league. Real Manhattan was less a roster than a document with edit access left on.',
    stat: '52 players',
  },
  {
    title: 'Old Lady won the Donnarumma traffic jam',
    body: 'Nic beat Real Manhattan, fent folders, and Big Micha to Donnarumma in GW4. Donnarumma then put up 120 points after the claim, because naturally the goalkeeper waiver became an incident.',
    stat: '120 pts',
  },
  {
    title: 'Woltemade became league property',
    body: 'Woltemade has been on Big Micha, Hookah, MBOOMO, and Old Lady. The man has a lease in four boroughs and points in none.',
    stat: '4 teams',
  },
]

export const runInStories = [
  {
    title: 'The trophy math',
    body: 'Rohit has the table lead and enough scoring underneath it that the staff cannot call the whole thing fake. We can say anything can happen. We can also read a calendar.',
    stat: '3 GW',
  },
  {
    title: 'The commissioner complaint',
    body: 'Teddy still has the points title case. If Real Manhattan finishes without the trophy, the end-of-year article will arrive with exhibits.',
    stat: '#1 PF',
  },
  {
    title: 'The schedule lawsuit',
    body: 'Son Doku is the danger team nobody wants to validate. Jonathan has the bad-beat file, a top-four scoring profile, and just enough season left to make ninth place look like a clerical error.',
    stat: '-12.54',
  },
  {
    title: 'The bottom program',
    body: 'Hookah and Shyam have three weeks to turn the last paragraph into something other than sentencing. One has tried too much. One has tried too little. Both have kept the writers busy.',
    stat: '13/14',
  },
]

export const dataFiles = [
  {
    label: 'Team metrics',
    href: '/fantasy/data/csv/team_metrics.csv',
    rows: '14 rows',
    detail:
      'The main table: standings, scoring rank, all-play expectation, schedule luck, and roster churn.',
  },
  {
    label: 'Weekly scores',
    href: '/fantasy/data/csv/weekly_scores.csv',
    rows: '490 rows',
    detail:
      'Every team score by completed gameweek, including opponents and results.',
  },
  {
    label: 'Transactions',
    href: '/fantasy/data/csv/transactions_enriched.csv',
    rows: '424 rows',
    detail:
      'Waivers and free-agent moves with post-pickup points and dropped-player regret.',
  },
  {
    label: 'Roster timeline',
    href: '/fantasy/data/csv/reconstructed_rosters.csv',
    rows: '6,825 rows',
    detail:
      'Weekly rosters reconstructed from draft, accepted moves, and trades.',
  },
  {
    label: 'Player metrics',
    href: '/fantasy/data/csv/player_metrics.csv',
    rows: '832 rows',
    detail:
      'Global FPL production, replacement value, current ownership, and FPL-BPM.',
  },
  {
    label: 'Python pipeline',
    href: '/fantasy/data/scripts/fetch_and_analyze.py',
    rows: 'script',
    detail:
      'The script that fetches the APIs, rebuilds rosters, writes CSVs, and renders charts.',
  },
]

export const leagueTiers = [
  {
    tier: 'Different league',
    teams: 'fent folders, Real Manhattan',
    body: 'Rohit and Teddy are the two teams over 1500-ish points. The table prefers Rohit, the raw scoring prefers Teddy, and everyone else is trying to make a case from below.',
  },
  {
    tier: 'Real contenders',
    teams: 'wadeland, Chunky jeet FC, Son Doku',
    body: 'Arush has the table position. Ashaank and Jonathan have the points profile. None of these teams should be comfortable playing each other.',
  },
  {
    tier: 'The crowded middle',
    teams: 'Leyverpool, Big Micha, MBOOMO, Yanited, Old Lady, A',
    body: 'This is the messy part of the league. Some have luck, some have names, some have a record week, and all of them have enough flaws for the staff to keep writing.',
  },
  {
    tier: 'Separate investigation',
    teams: 'Hookah Doncic, Shyam’s Your Daddy',
    body: 'Hookah has tried more things. Shyam has tried fewer things. The points suggest both clubs have earned their own paragraph away from polite society.',
  },
]

export const regretFiles = [
  {
    team: 'Real Manhattan',
    manager: 'Teddy',
    week: 'GW6',
    dropped: 'Gibbs-White',
    added: 'Bergvall',
    regret: 158,
    note: 'This is the big one. Teddy dropped Gibbs-White, then watched him become a season-changing player for Chunky jeet FC.',
  },
  {
    team: 'fent folders',
    manager: 'Rohit',
    week: 'GW4',
    dropped: 'Wilson',
    added: 'Yeremy',
    regret: 137,
    note: 'Even the league leader has a file in the cabinet. Wilson kept scoring after Rohit moved on.',
  },
  {
    team: 'MBOOMO',
    manager: 'Raed',
    week: 'GW2',
    dropped: 'Gravenberch',
    added: 'McAtee',
    regret: 129,
    note: 'Early-season tinkering is dangerous because nobody knows which quiet midfielder is about to become annoying.',
  },
  {
    team: 'Son Doku',
    manager: 'Jonathan',
    week: 'GW4',
    dropped: 'Matheus N.',
    added: 'Diakité',
    regret: 116,
    note: 'Son Doku already had the schedule working against him. This one did not help.',
  },
  {
    team: 'Hookah Doncic',
    manager: 'Arne',
    week: 'GW5',
    dropped: 'Van Hecke',
    added: 'Mavropanos',
    regret: 107,
    note: 'The pickup was not even bad. The dropped player simply became the kind of defender Hookah could not afford to lose.',
  },
]

export const playerCodes: Record<string, number> = {
  Wirtz: 494595,
  Odegaard: 184029,
  Ødegaard: 184029,
  Neto: 247632,
  Martinelli: 444145,
  Raul: 102057,
  Raúl: 102057,
  Guehi: 209036,
  Guéhi: 209036,
  Gakpo: 243298,
  Ballard: 223827,
  Leno: 80201,
  'B.Fernandes': 141746,
  Eze: 232413,
  Frimpong: 216094,
  'Ait-Nouri': 448514,
  'Aït-Nouri': 448514,
  Chalobah: 180736,
  Verbruggen: 489639,
  Thiaw: 465642,
  Haaland: 223094,
  'Gibbs-White': 222531,
  Gordon: 232826,
  Barry: 586309,
  'Mac Allister': 243016,
  Wilson: 75115,
  Kelleher: 200720,
  Gravenberch: 441266,
  'E.Le Fee': 484420,
  'E.Le Fée': 484420,
  Marmoush: 438234,
  Solanke: 154566,
  Cherki: 466052,
  Gabriel: 226597,
  Szoboszlai: 424876,
  Casemiro: 61256,
  Pickford: 111234,
  Watkins: 178301,
  Sesko: 485711,
  Šeško: 485711,
  Semenyo: 437730,
  Kudus: 460842,
  Kerkez: 544877,
  Thiago: 502500,
  'J.Timber': 445122,
  Mosquera: 501837,
  Gyokeres: 224117,
  Gyökeres: 224117,
  Mateta: 231747,
  'Strand Larsen': 247412,
  Sarr: 232185,
  Cucurella: 179268,
  'Dewsbury-Hall': 215413,
  Scott: 503139,
  Konate: 204716,
  Konaté: 204716,
  Schade: 513418,
  Palmer: 244851,
  Wissa: 216646,
  Evanilson: 444102,
  'Pedro Porro': 441164,
  Senesi: 221466,
  Anderson: 232820,
  Garner: 232928,
  Andersen: 174874,
  Isak: 219168,
  Wood: 60689,
  Rogers: 244850,
  Munoz: 247348,
  Muñoz: 247348,
  Gvardiol: 477424,
  Henderson: 172649,
  Richards: 427623,
  'O.Dango': 533463,
  Ekitike: 510663,
  Ekitiké: 510663,
  Cunha: 430871,
  Kluivert: 222683,
  Johnson: 514613,
  Maddison: 172780,
  Raya: 154561,
  Truffert: 494521,
  Tavernier: 201658,
  Aaronson: 427637,
  Mbeumo: 446008,
  Madueke: 248857,
  Elanga: 449434,
  Welbeck: 50175,
  Savinho: 510281,
  "O'Reilly": 472769,
  Tarkowski: 17761,
  'Matheus N.': 465351,
  'Van Hecke': 469142,
  Bowen: 178186,
  'Joao Pedro': 475168,
  'João Pedro': 475168,
  Amad: 493250,
  Saliba: 462424,
  Nkunku: 213198,
  Lacroix: 437499,
  'Bruno G.': 208706,
  Roefs: 498016,
  'M.Salah': 118748,
  Virgil: 97032,
  Mitoma: 451340,
  Rice: 204480,
  Rodrigo: 220566,
  Mukiele: 200834,
  Anthony: 444180,
  Saka: 223340,
  Foden: 209244,
  Havertz: 219847,
  Enzo: 448047,
  Delap: 463034,
  Mitchell: 244723,
  Cash: 199796,
  Bergvall: 570526,
  Yeremy: 488024,
  McAtee: 432714,
  Diakité: 242882,
  Sessegnon: 184349,
  Sancho: 209243,
  Doku: 248875,
  'Igor Jesus': 482973,
  Bassey: 232892,
  Muniz: 244042,
  Donnarumma: 204936,
  Woltemade: 470313,
  Nmecha: 174594,
  Osula: 538207,
  James: 225796,
  Alderete: 201895,
  Gusto: 482609,
  'Van de Ven': 491279,
  Mavropanos: 233963,
}

export const missingHeadshotCodes = new Set([242882, 482973, 488024])
export const selectedChartDefault = charts[0]!.slug

export const managerToTeam: Record<string, string> = {
  Rohit: 'fent folders',
  Arush: 'wadeland',
  Teddy: 'Real Manhattan',
  Leyland: 'Leyverpool',
  Nic: 'Old Lady',
  Ashaank: 'Chunky jeet FC',
  Ahmed: 'A',
  Hugh: 'Big Micha',
  Jonathan: 'Son Doku',
  "Ra'ed": 'MBOOMO',
  Akash: 'Yanited',
  Arne: 'Hookah Doncic',
  Shyam: 'Shyam’s Your Daddy',
}
